import { Platform } from "react-native";
import { Dispatch } from "redux";
import FirebaseHandler from "./FirebaseHandler";

export const onFirebaseHandler = (dispatch: Dispatch, accessToken: string) => {
  // ? === usage ===
  // === HomeScreen => handleOnServerChanged() === 
  // === WelcomeScreen => currentBuilding section & onProfileSelect() ===
  // === LoginScreen => onProfileSelect()
  
  try {
    if (Platform.OS === "ios" || Platform.OS === "android") {
      var firebaseHandler = new FirebaseHandler();
      firebaseHandler
        .requestPermission()
        .then((enabled) => {
          if (enabled) {
            firebaseHandler
              .getToken()
              .then((pushToken) => {
                dispatch({
                  type: "USER_UPDATE_PUSH_NOTIFICATION_TOKEN",
                  payload: { token: pushToken },
                  socket: { send: true, keepSocket: true },
                  accessToken: accessToken,
                });
              })
              .catch((e) => {
                console.log("error getToken FirebaseHandler", e);
              });
          }
        })
        .catch((error) => {
          console.log("error requestPermission() FirebaseHandler", error);
        });
    }
  } catch (e) {
    console.log("error onFirebaseHandler", e);
  }
};
